import { DataTableCell as RWMC, DataTableCellProps as RWMCProps } from "@rmwc/data-table"
import { HTMLAttributes } from "react"
import omit from "lodash/omit"
import { callCSSFn, CSS, CSSFn, styled, StylePropsWithCSS } from "../../styles"

export type DataTableCellProps = RWMCProps &
  HTMLAttributes<HTMLTableElement> & {
    css?: CSSFn
  }
const Component = (props: DataTableCellProps) => <RWMC {...omit(props, `css`)} />
Component.defaultProps = {
  css: undefined,
}
export const DataTableCell = styled(Component)(
  (props: StylePropsWithCSS): CSS => ({
    fontSize: props.theme.fontSize.body,
    ...callCSSFn(props),
  })
)
